function toIdSet(items = []) {
  return new Set(items.map(item => item.id ?? item))
}

function toNameSet(items = []) {
  return new Set(items.map(item => item.name ?? item))
}

function getFallbackScope(step) {
  if (step.template?.scope) {
    return step.template.scope
  }

  if (step.type === 'sign_document') {
    return step.body?.scope || null
  }

  return step.body?.template?.scope || null
}

function matchesScope(scope, associate = {}) {
  if (!scope) return false

  const { role, payment_info } = associate
  const { legal_entity, type: paymentType } = payment_info || {}
  const contractorSubType = legal_entity?.type
  const roleId = role?.parent_entity ?? role?.id
  const legalEntityId = legal_entity?.parent_entity ?? legal_entity?.id

  const {
    payment_types = [],
    roles = [],
    legal_entities = [],
    contractor_sub_types = [],
    exclude_payment_types = [],
    exclude_roles = [],
    exclude_legal_entities = [],
    exclude_contractor_sub_types = []
  } = scope

  const paymentTypesSet = new Set(payment_types)
  const excludedPaymentTypesSet = new Set(exclude_payment_types)
  const rolesSet = toIdSet(roles)
  const excludedRolesSet = toIdSet(exclude_roles)
  const legalEntitiesSet = toIdSet(legal_entities)
  const excludedLegalEntitiesSet = toIdSet(exclude_legal_entities)
  const contractorSubTypesSet = toNameSet(contractor_sub_types)
  const excludedContractorSubTypesSet = toNameSet(exclude_contractor_sub_types)

  const matchesPaymentType =
    (payment_types.length === 0 || paymentTypesSet.has(paymentType)) && !excludedPaymentTypesSet.has(paymentType)
  const matchesRole = (roles.length === 0 || rolesSet.has(roleId)) && !excludedRolesSet.has(roleId)
  const matchesLegalEntity =
    (legal_entities.length === 0 || legalEntitiesSet.has(legalEntityId)) &&
    !excludedLegalEntitiesSet.has(legalEntityId)
  const matchesContractorSubType =
    (contractor_sub_types.length === 0 || contractorSubTypesSet.has(contractorSubType)) &&
    !excludedContractorSubTypesSet.has(contractorSubType)

  return matchesPaymentType && matchesRole && matchesLegalEntity && matchesContractorSubType
}

export function getTargetAdminSteps(sequence, associate) {
  return (sequence?.admin_steps || []).filter(step => matchesScope(getFallbackScope(step), associate))
}
